import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { GetUrl } from "../config/GetUrl";

export const charityApi = createApi({
  reducerPath: "charityApi",
  baseQuery: fetchBaseQuery({
    baseUrl: GetUrl.API_URL,
  }),
  endpoints: (builder) => ({
    CreateCharityPost: builder.mutation({
      query: (data) => ({
        url: "/admin/add-charity",
        method: "POST",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    GetCharity: builder.query({
      query: () => ({
        url: "/admin/get-all-charity",
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    GetSingleCharity: builder.query({
      query: (id) => ({
        url: `/admin/get-single-charity/${id}`,
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    EditCharity: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/edit-charity/${id}`,
        method: "PUT",
        body: data,
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
    DeleteCharity: builder.mutation({
      query: (id) => ({
        url: `/admin/delete-charity/${id}`,
        method: "DELETE",
        headers: {
          authorization: `Bearer ${localStorage.getItem("tokenAdmin")}`,
        },
      }),
    }),
  }),
});

export const {
  useCreateCharityPostMutation,
  useGetCharityQuery,
  useGetSingleCharityQuery,
  useEditCharityMutation,
  useDeleteCharityMutation,
} = charityApi;
